import { z } from 'zod';

export const quotaResetScheduleSchema = z.enum(['monthly', 'weekly', 'daily', 'never']);

export const setUserQuotaInputSchema = z.object({
  quota: z.number().int().min(0, 'Quota must be non-negative'),
  resetUsage: z.boolean().default(false),
});

export const usagePeriodSchema = z.enum(['daily', 'weekly', 'monthly']);

export const usageQuerySchema = z.object({
  period: usagePeriodSchema.default('daily'),
  fromDate: z.string().date().optional(),
  toDate: z.string().date().optional(),
});

export type UsageQuery = z.infer<typeof usageQuerySchema>;
